// Mock data for Saketh Real Estate

export const projectsData = [
  {
    id: 1,
    name: "Golden Fortune",
    location: "Near Shadnagar, Hyderabad",
    description: "Mega Residential Township with DTCP approved layout",
    image: "https://customer-assets.emergentagent.com/job_0b620f1b-d797-4c34-8120-5a47e4d312db/artifacts/q6pkzqsj_31288.jpg",
    features: ["Gated Community", "Premium Amenities", "DTCP Approved"]
  },
  {
    id: 2,
    name: "Mahagiri Farms & Resorts",
    location: "Sarvepally, Yadagirigutta",
    description: "Red Sandal Farm Land Plots with exceptional ROI potential",
    image: "https://customer-assets.emergentagent.com/job_0b620f1b-d797-4c34-8120-5a47e4d312db/artifacts/y122iav3_31271.jpg",
    features: ["Farm Lands", "Red Sandalwood", "High Returns"]
  },
  {
    id: 3,
    name: "Vihari New City",
    location: "Talakondapally, Kadithal",
    description: "Premium Gated Community Open Plots near Srisailam Highway",
    image: "https://customer-assets.emergentagent.com/job_0b620f1b-d797-4c34-8120-5a47e4d312db/artifacts/lkcki9p7_31273.jpg",
    features: ["DTCP Approved", "Easy EMI", "Net Zero City"]
  },
  {
    id: 4,
    name: "Prakruti Avenues - Golden Fortune",
    location: "Multiple Locations - Telangana & AP",
    description: "Premium residential plots with flexible payment options",
    image: "https://customer-assets.emergentagent.com/job_0b620f1b-d797-4c34-8120-5a47e4d312db/artifacts/cctf6t9j_31275.jpg",
    features: ["Flexible Payment", "Multiple Locations", "RERA Approved"]
  },
  {
    id: 5,
    name: "Siri Laxmi Sai Projects",
    location: "Yadagirigutta & Surrounding Areas",
    description: "Buy a plot today, get triple returns with red sandalwood plantation",
    image: "https://customer-assets.emergentagent.com/job_0b620f1b-d797-4c34-8120-5a47e4d312db/artifacts/xy71ia71_31276.jpg",
    features: ["Triple Returns", "ISO Certified", "RERA Registered"]
  },
  {
    id: 6,
    name: "Vihari Location Advantage",
    location: "Near Regional Ring Road, Hyderabad",
    description: "Strategic location with excellent connectivity and appreciation potential",
    image: "https://customer-assets.emergentagent.com/job_saketh-luxury/artifacts/vs3zfood_31281.jpg",
    features: ["Prime Location", "High Appreciation", "Infrastructure Ready"]
  }
];

export const servicesData = [
  {
    title: "Property Buying",
    description: "Expert guidance in finding your dream property with verified documentation and transparent processes",
    icon: "Home"
  },
  {
    title: "Property Selling",
    description: "Maximize your property value with our strategic marketing and extensive buyer network",
    icon: "TrendingUp"
  },
  {
    title: "Investment Consulting",
    description: "Data-driven insights for high-ROI real estate investments tailored to your financial goals",
    icon: "Target"
  },
  {
    title: "Venture Marketing",
    description: "Comprehensive marketing solutions to promote and scale your real estate ventures effectively",
    icon: "Megaphone"
  }
];

export const whyChooseUsData = [
  {
    title: "Trusted Local Expertise",
    description: "Years of experience in Telangana and AP real estate markets",
    icon: "Award"
  },
  {
    title: "Verified Properties",
    description: "All properties thoroughly verified with proper documentation",
    icon: "ShieldCheck"
  },
  {
    title: "High ROI Opportunities",
    description: "Carefully curated investment options with proven returns",
    icon: "TrendingUp"
  },
  {
    title: "End-to-End Support",
    description: "Complete assistance from search to registration and beyond",
    icon: "Headset"
  }
];

export const contactInfo = {
  phones: ["9849739551", "7842139551"],
  email: "info@sakethrealestate.com",
  address: "2-71, Vani Nagar, Street No. 1, Malkajgiri, Hyderabad – 500047",
  mapLink: "https://maps.app.goo.gl/4Fpe64FyDyhsFqDu7",
  social: {
    facebook: "https://www.facebook.com/share/1NthC1LAnN/",
    instagram: "https://www.instagram.com/saketh_real_estate?igsh=cWk0eThlMjh4OWI="
  }
};

export const founderInfo = {
  name: "Sriram Jagannath",
  title: "Founder",
  description: "Sriram Jagannath leads Saketh Real Estate with a vision to deliver trusted property solutions and powerful venture marketing strategies.",
  image: "https://customer-assets.emergentagent.com/job_saketh-luxury/artifacts/y8g5w3t5_31299.jpg"
};

export const missionVision = {
  mission: "To provide reliable, transparent, and profitable real estate solutions while helping ventures grow through strategic marketing.",
  vision: "To become a leading real estate and venture marketing brand known for trust, quality, and results."
};
